// src/pages/CallbackPage.jsx
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { verifyCodeAPI } from "../features/auth/authAPI";
import { DEFAULT_TAB_PATH } from "./HomePage";
import { loginSuccess, loginFailure } from "../features/auth/authSlice";
import "../styles/loader.css";
import { authService } from "../services/authService";
import { consumePostLoginRedirect } from "../services/postLoginRedirect";

function CallbackPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const verifyCode = async () => {
      const code = searchParams.get("code");
      const codeChallenge = searchParams.get("state");
      if (!code || !codeChallenge) {
        alert("로그인에 실패했습니다. 다시 시도해주세요.");
        navigate("/login");
        return;
      }

      const data = {
        code: code,
        code_challenge: codeChallenge,
      };

      try {
        const response = await verifyCodeAPI(data);

        const accessToken = response.data["access_token"];
        const refreshToken = response.data["refresh_token"];
        authService.setTokens(accessToken, refreshToken);

        if (response.status === 200) {
          dispatch(loginSuccess());
          // 로그인하러 떠나기 전에 가려던 곳이 있으면 그리로. 없으면 기본 메뉴로.
          // 랜딩에서 레벨테스트 화면으로 바로 걸어 둔 링크가 여기서 살아난다.
          navigate(consumePostLoginRedirect() || DEFAULT_TAB_PATH);
        } else {
          dispatch(loginFailure());
          alert("로그인에 실패했습니다. 다시 시도해주세요.");
          navigate("/login");
        }
      } catch (error) {
        dispatch(loginFailure());
        alert("로그인에 실패했습니다. 다시 시도해주세요.");
        navigate("/login");
      }
    };

    verifyCode();
  }, [dispatch, navigate, searchParams]);

  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
}

export default CallbackPage;
